module.exports = __webpack_public_path__ + "static/media/story-good-deed.d0980b84.svg";